module.exports = __webpack_public_path__ + "app/components/feedback/feedback.view.html";